export const filterStaticPagesByInstance = (menuItems, isClubsDomain)  => {
  return menuItems.filter(item => 
    item.instance.some(instance => 
      instance.toLowerCase() === (isClubsDomain ? "clubs-hq" : "hq")
    )
  );
}